<template>
  <div>
    <div v-if="pdf" class="flip-book-container" :src="pdf"></div>
  </div>
</template>

<script>
/* What's Buzzing issue flipbook
 *
 * @parent:
 * @requests:
 * @events:
 * @props:
 * @components:
 * @methods:
 */

import issues from '~/data/whats_buzzing.json';

export default {
  name: 'WhatsBuzzingYearIssue',
  layout: 'basic',
  data() {
    return {
      title: "What's Buzzing Magazine",
      description: '',
      pdf: null,
    };
  },
  head() {
    return {
      title: this.title,
      meta: [
        { hid: 'title', name: 'title', content: this.title },
        {
          hid: 'description',
          name: 'description',
          content: this.description,
        },
      ],
      script: [
        {
          hid: 'jqueryjs',
          src: 'https://cdn.jsdelivr.net/npm/jquery@3.4.1/dist/jquery.min.js',
        },
        {
          hid: 'pdfjs',
          src: 'https://cdn.jsdelivr.net/npm/pdfjs-dist@v2.0.118/build/pdf.min.js',
        },
        {
          hid: 'html2canvas',
          src: 'https://cdn.jsdelivr.net/npm/html2canvas@1.0.0-rc.3/dist/html2canvas.min.js',
        },
        {
          hid: 'threejs',
          src: 'https://cdn.jsdelivr.net/npm/three@0.81/build/three.min.js',
        },
        {
          hid: 'flip_book_plugin',
          src: '/flipbook_assets/js/plugin-flip-book.min.js',
          defer: true,
        },
      ],
    };
  },
  mounted() {
    // for testing
    if (this.$route.params.issue === 'test') {
      this.pdf = '/flipbook_assets/preview-test.pdf';
      return;
    }

    const issue = issues[this.$i18n.locale].find(i => i.slug === this.$route.params.issue);
    const year = issue.years.find(y => y.slug === this.$route.params.year);
    this.pdf = year ? this.$config.wpURL + year.pdf : null;
  },
};
</script>

<style scoped>
* {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  font-family: sans-serif;
}

html,
body,
.flip-book-container {
  height: 100vh;
  width: 100%;
}

.flip-book-container {
  overflow: hidden;
}

iframe {
  border: none;
  height: 100%;
  width: 100%;
}
</style>
